export const getId = (value: any) => typeof value === "object" ? value?.id : value;

export const getShiftInfo = (request: any) => {
    const schedule = request?.data?.schedule;
    const section = schedule?.sections?.[0];
    const startDate = schedule?.startDate || request?.data?.startDate;

    return {
        section,
        owner: request?.data?.originalUser || request?.user,
        date: schedule?.date || startDate,
        startDate,
        endDate: schedule?.endDate || request?.data?.endDate,
        job: section?.job || request?.data?.job,
        location: section?.location || request?.data?.location,
    };
};
